import React, { useEffect, useState } from 'react';
import AboutContent from "../Components/About/AboutContent";
import Footer from "../Components/Footer/Footer";
import UserNavigation from '../Components/v1/NavBar/Navigaton';
import { Helmet } from "react-helmet";
import ServicesCount from '../Components/v1/Services/ServicesCount';
import Newsletter from '../Components/v1/Home/Newletter';
import ScheduleMeetBanner from '../Components/v1/Home/ScheduleMeetBanner';
import HomeClientStrip from '../Components/v1/Homev2/HomeClientStrip';
import { fetchBestServices, fetchServicesCount } from '../Api/v1/service/Api';
import { useNavigate } from 'react-router-dom';
import HomeConsult from '../Components/v1/Homev2/HomeConsult';
import HomeAboutIntro from '../Components/v1/Homev2/HomeAboutIntro';
import HomeTopServices from '../Components/v1/Homev2/HomeTopServices';
import HomeServices from '../Components/v1/Homev2/HomeServices';

export default function About() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const goToService = data => e => {
    e.preventDefault();
    navigate(`/services/${data.mainServiceName?.toLowerCase()}/${data.title?.toLowerCase().replace(/\s+/g, '-')}/${data._id}`);
  };

  const navigate = useNavigate();
  const [servicesCount, setServicesCount] = useState({});
  const [bestServices, setBestServices] = useState([]);

  useEffect(() => {
    const getBestServices = async () => {
      let data = await fetchBestServices();
      if (data && data.statusCode === 200) setBestServices(data?.data);
      else setBestServices([]);
    };
    const getServicesCount = async () => {
      let data = await fetchServicesCount();
      if (data && data.statusCode === 200) setServicesCount(data?.data);
      else setServicesCount({});
    };
    getBestServices();
    getServicesCount();

    // Scroll-reveal observer
    const revealItems = document.querySelectorAll(
      '.dalmaf-home .intro, .dalmaf-home .stats div, .dalmaf-home .service-card, .dalmaf-home .command, .dalmaf-home .compact-grid article, .dalmaf-home .product-card, .dalmaf-home .consult, .dalmaf-home .contact'
    );
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.body.classList.add('motion-ready');
      revealItems.forEach(item => item.classList.add('reveal'));
      const observer = new IntersectionObserver(
        entries => entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); observer.unobserve(e.target); }
        }),
        { threshold: 0.16 }
      );
      revealItems.forEach(item => observer.observe(item));
      return () => revealItems.forEach(item => observer.unobserve(item));
    } else {
      revealItems.forEach(item => item.classList.add('is-visible'));
    }
  }, []);

  const goTo = path => e => { e.preventDefault(); navigate(path); };

  return (
    <div className="dalmaf-home">
      <Helmet>
        <meta charSet="utf-8" />
        <title>About DALMaf Private Limited</title>
        <link rel="canonical" href={window.location.href} />
        <meta name="description" content="We are happy to Introduce the Dalmaf Company, the one-stop destination for Legal, Auditing, Bank Auction Support, Buying and Selling, and Marketing Assistance. Founded in June of 2022 as a Global Market Pioneer for offering comprehensive company solutions in all aspects, Our team of Professionals is Passionate about aiding businesses in Resolving Difficulties, Strengthening their Internal Operations, and Realising their ultimate goal." />
        <meta name="keywords" content="DALMaf, about, legal, audit, bank auction, business solutions" />
        <meta name="author" content="DALMaf" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>

      <div id="container">
        <UserNavigation />

        <HomeAboutIntro />
        <HomeServices bestServices={bestServices.slice(0, 3)} onGoTo={goTo} onServiceClick={goToService} />
        {/* <ServicesCount /> */}
        <AboutContent />
        <HomeConsult onGoTo={goTo} />
        {/* <ScheduleMeetBanner /> */}
        <Newsletter />
        <Footer />
      </div>
    </div>
  );
}
